export const IconLabelButtonTypes = {
  CLEAR: 0,
  BLUE: 1,
  GREY: 2,
};

export const IconLabelButtonSizes = {
  SMALL: 0,
  MEDIUM: 1,
  LARGE: 2,
};
